function MoreLessToggle() {
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var btnText = document.getElementById("MrLsButton");
    
    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Lees Meer";
        moreText.style.display = "none";
        btnText.style.marginTop = "0px";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Lees Minder";
        moreText.style.display = "inline";
        btnText.style.marginTop = "30px";
    }
}
